import { render } from "./AddApproverLibrary.vue?vue&type=template&id=5ef7af7f&scoped=true"
import script from "./AddApproverLibrary.vue?vue&type=script&lang=js"
export * from "./AddApproverLibrary.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./AddApproverLibrary.vue?vue&type=style&index=1&id=5ef7af7f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef7af7f"]])

export default __exports__